import { REVIEWS_REDUCER_ADD, REVIEWS_REDUCER_UPDATE } from 'actions/meshlistReviews';

export default function reviewsReducer(state = [], action) {
  switch (action.type) {
    case REVIEWS_REDUCER_ADD: {
      return [...state, ...action.reviews];
    }
    case REVIEWS_REDUCER_UPDATE: {
      return [...action.reviews];
    }
    default: {
      return state;
    }
  }
}
